import "./CompiHero.css"

function Chero(){
    return(
      <div className="chero-background">
        <div class="position-relative p-3 p-md-5 text-center" >
    <div class="col-md-6 p-lg-5 mx-auto my-5">
      <h1 class="display-3 fw-bold">Competitions</h1>
      <h3 class="fw-normal mb-3" >Events in which we have participated</h3>
    </div>
  </div>
        </div>

    )
}

export default Chero;